import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './vapt-as-a-service-overview.css'

const VAPTAsAServiceOverview = (props) => {
  return (
    <div className="vapt-as-a-service-overview-container1">
      <Helmet>
        <title>Cysigil Network Pvt Ltd</title>
        <meta
          property="og:title"
          content="VAPT-as-a-Service-Overview - Well Off Notable Fish"
        />
        <link
          rel="canonical"
          href="https://well-off-notable-fish-gmgkwg.teleporthq.app/vapt-as-a-service-overview"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="hero-vapt">
        <div className="hero-vapt-media-wrapper">
          <video
            src="https://videos.pexels.com/video-files/6963744/6963744-hd_1280_720_25fps.mp4"
            loop="true"
            muted="true"
            poster="https://images.pexels.com/videos/6963744/pictures/preview-0.jpg"
            autoPlay="true"
            playsInline="true"
            className="hero-vapt-video"
          ></video>
          <div className="hero-vapt-overlay"></div>
        </div>
        <div className="hero-vapt-content-wrapper">
          <div className="hero-vapt-content">
            <div className="hero-vapt-badge">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                  <path d="m9 12l2 2l4-4"></path>
                </g>
              </svg>
              <span>Enterprise-Grade Security Testing</span>
            </div>
            <h1 className="hero-title">VAPT as a Service</h1>
            <p className="hero-subtitle">
              Comprehensive vulnerability assessment and penetration testing
              across your entire technology stack. Identify, prioritize, and
              remediate security weaknesses before they become breaches.
            </p>
            <div className="hero-vapt-stats">
              <div className="hero-vapt-stat-item">
                <span className="hero-vapt-stat-value">9</span>
                <span className="hero-vapt-stat-label">
                  Testing Domains Completed
                </span>
              </div>
              <div className="hero-vapt-stat-item">
                <span className="hero-vapt-stat-value">100%</span>
                <span className="hero-vapt-stat-label">OWASP Aligned</span>
              </div>
              <div className="hero-vapt-stat-item">
                <span className="hero-vapt-stat-value">24/7</span>
                <span className="hero-vapt-stat-label">Support Coverage</span>
              </div>
            </div>
            <div className="hero-vapt-cta-group">
              <a href="#contact">
                <div className="btn-primary btn btn-lg">
                  <span>Request Assessment</span>
                </div>
              </a>
              <a href="#roadmap">
                <div className="btn btn-lg btn-outline">
                  <span>View Roadmap</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <section className="services-completed">
        <div className="services-completed-container">
          <div className="services-completed-header">
            <h2 className="section-title">Completed Testing Capabilities</h2>
            <p className="section-subtitle">
              Nine specialized security testing domains ready for immediate
              deployment to protect your digital assets
            </p>
          </div>
          <div className="services-completed-grid">
            <article className="services-completed-card">
              <div className="services-completed-card-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="m16 18l6-6l-6-6M8 6l-6 6l6 6"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="services-completed-card-title">
                LLM Penetration Testing
              </h3>
              <p className="services-completed-card-description">
                Specialized testing for Large Language Models, prompt injection
                attacks, data leakage vulnerabilities, and AI model security
                assessments.
              </p>
              <div className="services-completed-card-badge">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 6L9 17l-5-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <span>Ready</span>
              </div>
            </article>
            <article className="services-completed-card">
              <div className="services-completed-card-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="8" cx="11" cy="11"></circle>
                    <path d="m21 21l-4.3-4.3"></path>
                  </g>
                </svg>
              </div>
              <h3 className="services-completed-card-title">
                Web Application Security
              </h3>
              <p className="services-completed-card-description">
                Comprehensive testing covering OWASP Top 10, SQL injection, XSS,
                CSRF, authentication flaws, and business logic vulnerabilities.
              </p>
              <div className="services-completed-card-badge">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 6L9 17l-5-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <span>Ready</span>
              </div>
            </article>
            <article className="services-completed-card">
              <div className="services-completed-card-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse>
                    <path d="M3 5v14a9 3 0 0 0 18 0V5"></path>
                    <path d="M3 12a9 3 0 0 0 18 0"></path>
                  </g>
                </svg>
              </div>
              <h3 className="services-completed-card-title">
                API Security Testing
              </h3>
              <p className="services-completed-card-description">
                REST, GraphQL, and SOAP API testing including authentication
                bypass, injection attacks, rate limiting, and data exposure
                analysis.
              </p>
              <div className="services-completed-card-badge">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 6L9 17l-5-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <span>Ready</span>
              </div>
            </article>
            <article className="services-completed-card">
              <div className="services-completed-card-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect
                      x="3"
                      y="11"
                      rx="2"
                      ry="2"
                      width="18"
                      height="11"
                    ></rect>
                    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="services-completed-card-title">
                Mobile Application Security
              </h3>
              <p className="services-completed-card-description">
                iOS and Android security testing, insecure data storage, reverse
                engineering, runtime manipulation, and mobile-specific
                vulnerabilities.
              </p>
              <div className="services-completed-card-badge">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 6L9 17l-5-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <span>Ready</span>
              </div>
            </article>
            <article className="services-completed-card">
              <div className="services-completed-card-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                    <path d="M14 2v5a1 1 0 0 0 1 1h5m-10 4.5L8 15l2 2.5m4-5l2 2.5l-2 2.5"></path>
                  </g>
                </svg>
              </div>
              <h3 className="services-completed-card-title">
                Source Code Review
              </h3>
              <p className="services-completed-card-description">
                Manual and automated code analysis for security flaws, hardcoded
                secrets, cryptographic weaknesses, and insecure coding patterns.
              </p>
              <div className="services-completed-card-badge">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 6L9 17l-5-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <span>Ready</span>
              </div>
            </article>
            <article className="services-completed-card">
              <div className="services-completed-card-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="10" cx="12" cy="12"></circle>
                    <circle r="6" cx="12" cy="12"></circle>
                    <circle r="2" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="services-completed-card-title">
                Thick Client Security
              </h3>
              <p className="services-completed-card-description">
                Desktop application security testing including local data
                validation, privilege escalation, and client-side business logic
                flaws.
              </p>
              <div className="services-completed-card-badge">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 6L9 17l-5-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <span>Ready</span>
              </div>
            </article>
            <article className="services-completed-card">
              <div className="services-completed-card-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
                    <path d="m19 9l-5 5l-4-4l-3 3"></path>
                  </g>
                </svg>
              </div>
              <h3 className="services-completed-card-title">
                Blockchain Security
              </h3>
              <p className="services-completed-card-description">
                Smart contract audits, consensus mechanism analysis, wallet
                security, and DeFi protocol vulnerability assessments.
              </p>
              <div className="services-completed-card-badge">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 6L9 17l-5-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <span>Ready</span>
              </div>
            </article>
            <article className="services-completed-card">
              <div className="services-completed-card-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="services-completed-card-title">IoT Security</h3>
              <p className="services-completed-card-description">
                IoT device testing, firmware analysis, communication protocol
                security, and embedded system vulnerability identification.
              </p>
              <div className="services-completed-card-badge">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 6L9 17l-5-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <span>Ready</span>
              </div>
            </article>
            <article className="services-completed-card">
              <div className="services-completed-card-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="M6.376 18.91a6 6 0 0 1 11.249.003"></path>
                    <circle r="4" cx="12" cy="11"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="services-completed-card-title">OT Security</h3>
              <p className="services-completed-card-description">
                Operational technology assessments for industrial control
                systems, SCADA networks, and critical infrastructure security
                testing.
              </p>
              <div className="services-completed-card-badge">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M20 6L9 17l-5-5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
                <span>Ready</span>
              </div>
            </article>
          </div>
        </div>
      </section>
      <section id="roadmap" className="timeline-roadmap">
        <div className="timeline-roadmap-wrapper">
          <div className="timeline-roadmap-header">
            <h2 className="section-title">Testing Capability Roadmap</h2>
            <p className="section-subtitle">
              Upcoming security testing domains to expand our comprehensive VAPT
              service offerings
            </p>
          </div>
          <div className="timeline-roadmap-scroll-container">
            <div className="timeline-roadmap-track">
              <div className="timeline-roadmap-item">
                <div className="timeline-roadmap-marker">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M12 6v6l4 2"></path>
                      <circle r="10" cx="12" cy="12"></circle>
                    </g>
                  </svg>
                </div>
                <div className="timeline-roadmap-content">
                  <span className="timeline-roadmap-date">Q2 2025</span>
                  <h3 className="timeline-roadmap-title">
                    Network Security Testing
                  </h3>
                  <p className="timeline-roadmap-description">
                    Comprehensive network infrastructure testing including
                    segmentation, lateral movement, and perimeter security
                    assessments.
                  </p>
                </div>
              </div>
              <div className="timeline-roadmap-item">
                <div className="timeline-roadmap-marker">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M12 6v6l4 2"></path>
                      <circle r="10" cx="12" cy="12"></circle>
                    </g>
                  </svg>
                </div>
                <div className="timeline-roadmap-content">
                  <span className="timeline-roadmap-date">Q2 2025</span>
                  <h3 className="timeline-roadmap-title">
                    Firewall Configuration Review
                  </h3>
                  <p className="timeline-roadmap-description">
                    In-depth analysis of firewall rule sets, policy
                    misconfigurations, and network segmentation effectiveness.
                  </p>
                </div>
              </div>
              <div className="timeline-roadmap-item">
                <div className="timeline-roadmap-marker">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M4 22V4a1 1 0 0 1 .4-.8A6 6 0 0 1 8 2c3 0 5 2 7.333 2q2 0 3.067-.8A1 1 0 0 1 20 4v10a1 1 0 0 1-.4.8A6 6 0 0 1 16 16c-3 0-5-2-8-2a6 6 0 0 0-4 1.528"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
                <div className="timeline-roadmap-content">
                  <span className="timeline-roadmap-date">Q3 2025</span>
                  <h3 className="timeline-roadmap-title">Container Security</h3>
                  <p className="timeline-roadmap-description">
                    Docker, Kubernetes, and container orchestration security
                    testing including image vulnerabilities and runtime
                    protection.
                  </p>
                </div>
              </div>
              <div className="timeline-roadmap-item">
                <div className="timeline-roadmap-marker">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M4 22V4a1 1 0 0 1 .4-.8A6 6 0 0 1 8 2c3 0 5 2 7.333 2q2 0 3.067-.8A1 1 0 0 1 20 4v10a1 1 0 0 1-.4.8A6 6 0 0 1 16 16c-3 0-5-2-8-2a6 6 0 0 0-4 1.528"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
                <div className="timeline-roadmap-content">
                  <span className="timeline-roadmap-date">Q3 2025</span>
                  <h3 className="timeline-roadmap-title">
                    Wireless Security Assessment
                  </h3>
                  <p className="timeline-roadmap-description">
                    Wi-Fi, Bluetooth, and other wireless protocol testing for
                    encryption weaknesses and unauthorized access points.
                  </p>
                </div>
              </div>
              <div className="timeline-roadmap-item">
                <div className="timeline-roadmap-marker">
                  <svg
                    width="24"
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M4 22V4a1 1 0 0 1 .4-.8A6 6 0 0 1 8 2c3 0 5 2 7.333 2q2 0 3.067-.8A1 1 0 0 1 20 4v10a1 1 0 0 1-.4.8A6 6 0 0 1 16 16c-3 0-5-2-8-2a6 6 0 0 0-4 1.528"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
                <div className="timeline-roadmap-content">
                  <span className="timeline-roadmap-date">Q4 2025</span>
                  <h3 className="timeline-roadmap-title">
                    Social Engineering Testing
                  </h3>
                  <p className="timeline-roadmap-description">
                    Phishing campaigns, pretexting, and human vulnerability
                    assessments to evaluate organizational security awareness.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="process-approach">
        <div className="process-approach-container">
          <div className="process-approach-header">
            <h2 className="section-title">Our VAPT Engagement Process</h2>
            <p className="section-subtitle">
              A risk-based, methodical approach to identifying and prioritizing
              security vulnerabilities
            </p>
          </div>
          <div className="process-approach-steps">
            <div className="process-approach-step">
              <div className="process-approach-step-number">
                <span>01</span>
              </div>
              <div className="process-approach-step-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="10" cx="12" cy="12"></circle>
                    <circle r="6" cx="12" cy="12"></circle>
                    <circle r="2" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="process-approach-step-title">
                Scoping &amp; Planning
              </h3>
              <p className="process-approach-step-description">
                Define testing objectives, identify critical assets, establish
                rules of engagement, and align testing methodology with business
                goals.
              </p>
              <div className="process-approach-arrow">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M5 12h14m-7-7l7 7l-7 7"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
            </div>
            <div className="process-approach-step">
              <div className="process-approach-step-number">
                <span>02</span>
              </div>
              <div className="process-approach-step-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="8" cx="11" cy="11"></circle>
                    <path d="m21 21l-4.3-4.3"></path>
                  </g>
                </svg>
              </div>
              <h3 className="process-approach-step-title">
                Reconnaissance &amp; Discovery
              </h3>
              <p className="process-approach-step-description">
                Conduct thorough information gathering, asset mapping,
                technology fingerprinting, and attack surface enumeration.
              </p>
              <div className="process-approach-arrow">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M5 12h14m-7-7l7 7l-7 7"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
            </div>
            <div className="process-approach-step">
              <div className="process-approach-step-number">
                <span>03</span>
              </div>
              <div className="process-approach-step-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="M12 8v4m0 4h.01"></path>
                  </g>
                </svg>
              </div>
              <h3 className="process-approach-step-title">
                Vulnerability Assessment
              </h3>
              <p className="process-approach-step-description">
                Execute automated scans and manual testing techniques to
                identify security weaknesses, misconfigurations, and known
                vulnerabilities.
              </p>
              <div className="process-approach-arrow">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M5 12h14m-7-7l7 7l-7 7"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
            </div>
            <div className="process-approach-step">
              <div className="process-approach-step-number">
                <span>04</span>
              </div>
              <div className="process-approach-step-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="10" cx="12" cy="12"></circle>
                    <circle r="6" cx="12" cy="12"></circle>
                    <circle r="2" cx="12" cy="12"></circle>
                  </g>
                </svg>
              </div>
              <h3 className="process-approach-step-title">
                Exploitation &amp; Validation
              </h3>
              <p className="process-approach-step-description">
                Safely exploit discovered vulnerabilities to validate severity,
                demonstrate business impact, and assess exploitability.
              </p>
              <div className="process-approach-arrow">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M5 12h14m-7-7l7 7l-7 7"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
            </div>
            <div className="process-approach-step">
              <div className="process-approach-step-number">
                <span>05</span>
              </div>
              <div className="process-approach-step-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
                    <path d="m19 9l-5 5l-4-4l-3 3"></path>
                  </g>
                </svg>
              </div>
              <h3 className="process-approach-step-title">
                Risk Analysis &amp; Prioritization
              </h3>
              <p className="process-approach-step-description">
                Assess findings using CVSS scoring, business context, and
                exploitability to prioritize remediation efforts by risk level.
              </p>
              <div className="process-approach-arrow">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M5 12h14m-7-7l7 7l-7 7"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
            </div>
            <div className="process-approach-step">
              <div className="process-approach-step-number">
                <span>06</span>
              </div>
              <div className="process-approach-step-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="process-approach-step-title">
                Reporting &amp; Remediation Guidance
              </h3>
              <p className="process-approach-step-description">
                Deliver comprehensive findings with executive summaries,
                technical details, proof-of-concept exploits, and actionable
                remediation roadmap.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="docs-deliverables">
        <div className="docs-deliverables-container">
          <div className="docs-deliverables-header">
            <h2 className="section-title">What You Receive</h2>
            <p className="section-subtitle">
              Comprehensive documentation and actionable insights to secure your
              infrastructure
            </p>
          </div>
          <div className="docs-deliverables-grid">
            <article className="docs-deliverables-card">
              <div className="docs-deliverables-card-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="docs-deliverables-card-title">
                Executive Summary Report
              </h3>
              <p className="docs-deliverables-card-description">
                High-level overview of security posture, critical findings,
                business impact assessment, and strategic recommendations for
                leadership.
              </p>
            </article>
            <article className="docs-deliverables-card">
              <div className="docs-deliverables-card-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"></path>
                    <path d="M14 2v5a1 1 0 0 0 1 1h5m-10 4.5L8 15l2 2.5m4-5l2 2.5l-2 2.5"></path>
                  </g>
                </svg>
              </div>
              <h3 className="docs-deliverables-card-title">
                Technical Findings Report
              </h3>
              <p className="docs-deliverables-card-description">
                Detailed vulnerability documentation including CVSS scores,
                attack vectors, proof-of-concept exploits, and step-by-step
                reproduction.
              </p>
            </article>
            <article className="docs-deliverables-card">
              <div className="docs-deliverables-card-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M3 3v16a2 2 0 0 0 2 2h16"></path>
                    <path d="m19 9l-5 5l-4-4l-3 3"></path>
                  </g>
                </svg>
              </div>
              <h3 className="docs-deliverables-card-title">
                Risk Rating Matrix
              </h3>
              <p className="docs-deliverables-card-description">
                Comprehensive risk assessment matrix categorizing
                vulnerabilities by severity, exploitability, and potential
                business impact.
              </p>
            </article>
            <article className="docs-deliverables-card">
              <div className="docs-deliverables-card-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M4 22V4a1 1 0 0 1 .4-.8A6 6 0 0 1 8 2c3 0 5 2 7.333 2q2 0 3.067-.8A1 1 0 0 1 20 4v10a1 1 0 0 1-.4.8A6 6 0 0 1 16 16c-3 0-5-2-8-2a6 6 0 0 0-4 1.528"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
              <h3 className="docs-deliverables-card-title">
                Remediation Roadmap
              </h3>
              <p className="docs-deliverables-card-description">
                Prioritized action plan with specific remediation steps,
                timelines, effort estimations, and security best practice
                recommendations.
              </p>
            </article>
            <article className="docs-deliverables-card">
              <div className="docs-deliverables-card-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="m16 18l6-6l-6-6M8 6l-6 6l6 6"></path>
                  </g>
                </svg>
              </div>
              <h3 className="docs-deliverables-card-title">
                Proof of Concept Code
              </h3>
              <p className="docs-deliverables-card-description">
                Safe, sanitized exploit code and payloads used during testing to
                demonstrate vulnerability exploitation methods.
              </p>
            </article>
            <article className="docs-deliverables-card">
              <div className="docs-deliverables-card-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 6L9 17l-5-5"></path>
                  </g>
                </svg>
              </div>
              <h3 className="docs-deliverables-card-title">
                Retest Verification
              </h3>
              <p className="docs-deliverables-card-description">
                Post-remediation testing to verify fixes, validate security
                improvements, and provide confirmation of vulnerability closure.
              </p>
            </article>
          </div>
        </div>
      </section>
      <section className="vapt-as-a-service-overview-cta-engagement">
        <div className="cta-engagement-wrapper">
          <div className="cta-engagement-column">
            <div className="vapt-as-a-service-overview-cta-engagement-icon">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                  <path d="m9 12l2 2l4-4"></path>
                </g>
              </svg>
            </div>
            <h3 className="cta-engagement-title">Free Security Consultation</h3>
            <p className="cta-engagement-description">
              Schedule a 30-minute consultation with our security experts to
              discuss your testing needs and threat landscape.
            </p>
            <a href="#contact">
              <div className="btn-primary btn">
                <span>Book Consultation</span>
              </div>
            </a>
          </div>
          <div className="cta-engagement-column">
            <div className="vapt-as-a-service-overview-cta-engagement-icon">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle r="8" cx="11" cy="11"></circle>
                  <path d="m21 21l-4.3-4.3"></path>
                </g>
              </svg>
            </div>
            <h3 className="cta-engagement-title">
              Comprehensive Security Assessment
            </h3>
            <p className="cta-engagement-description">
              Request a tailored VAPT proposal aligned with your infrastructure,
              compliance requirements, and security objectives.
            </p>
            <a href="#assessment">
              <div className="btn btn-secondary">
                <span>Request Assessment</span>
              </div>
            </a>
          </div>
          <div className="cta-engagement-column">
            <div className="vapt-as-a-service-overview-cta-engagement-icon">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </div>
            <h3 className="cta-engagement-title">Download VAPT Framework</h3>
            <p className="cta-engagement-description">
              Access our detailed testing methodology document outlining VAPT
              scope, processes, and deliverable specifications.
            </p>
            <a href="#download">
              <div className="btn btn-outline">
                <span>Download PDF</span>
              </div>
            </a>
          </div>
        </div>
      </section>
      <section className="about-standards">
        <div className="about-standards-container">
          <div className="about-standards-header">
            <h2 className="section-title">Aligned with Industry Standards</h2>
            <p className="section-subtitle">
              Our VAPT methodology adheres to globally recognized security
              frameworks and compliance requirements
            </p>
          </div>
          <div className="about-standards-grid">
            <article className="about-standards-card">
              <div className="about-standards-card-logo">
                <span className="about-standards-card-acronym">OWASP</span>
              </div>
              <h3 className="about-standards-card-title">OWASP ASVS</h3>
              <p className="about-standards-card-description">
                Application Security Verification Standard provides a basis for
                testing technical security controls and comprehensive
                application testing framework.
              </p>
            </article>
            <article className="about-standards-card">
              <div className="about-standards-card-logo">
                <span className="about-standards-card-acronym">PCI</span>
              </div>
              <h3 className="about-standards-card-title">PCI-DSS Compliance</h3>
              <p className="about-standards-card-description">
                Payment Card Industry Data Security Standard mandates
                penetration testing for organizations handling cardholder data,
                ensuring transaction security.
              </p>
            </article>
            <article className="about-standards-card">
              <div className="about-standards-card-logo">
                <span className="about-standards-card-acronym">ISO</span>
              </div>
              <h3 className="about-standards-card-title">ISO 27001</h3>
              <p className="about-standards-card-description">
                Information security management systems standard requiring
                vulnerability assessments and penetration testing as part of
                security controls.
              </p>
            </article>
            <article className="about-standards-card">
              <div className="about-standards-card-logo">
                <span className="about-standards-card-acronym">NIST</span>
              </div>
              <h3 className="about-standards-card-title">
                NIST Cybersecurity Framework
              </h3>
              <p className="about-standards-card-description">
                Identify, Protect, Detect, Respond, Recover framework guides
                risk-based vulnerability management and continuous security
                improvement.
              </p>
            </article>
            <article className="about-standards-card">
              <div className="about-standards-card-logo">
                <span className="about-standards-card-acronym">PTES</span>
              </div>
              <h3 className="about-standards-card-title">
                Penetration Testing Execution Standard
              </h3>
              <p className="about-standards-card-description">
                Industry-standard methodology defining phases of penetration
                testing from pre-engagement to reporting, ensuring thorough
                assessments.
              </p>
            </article>
            <article className="about-standards-card">
              <div className="about-standards-card-logo">
                <span className="about-standards-card-acronym">GDPR</span>
              </div>
              <h3 className="about-standards-card-title">
                GDPR Security Testing
              </h3>
              <p className="about-standards-card-description">
                General Data Protection Regulation requires regular security
                testing to ensure appropriate technical measures protect
                personal data.
              </p>
            </article>
          </div>
        </div>
      </section>
      <div className="vapt-as-a-service-overview-container2">
        <div className="vapt-as-a-service-overview-container3">
          <Script
            html={`<script defer data-name="timeline-scroll">
(function(){
  const timelineContainer = document.querySelector(".timeline-roadmap-scroll-container")

  if (timelineContainer) {
    let isScrolling

    timelineContainer.addEventListener(
      "scroll",
      function () {
        window.clearTimeout(isScrolling)

        isScrolling = setTimeout(function () {
          const scrollLeft = timelineContainer.scrollLeft
          const scrollWidth = timelineContainer.scrollWidth
          const clientWidth = timelineContainer.clientWidth

          if (scrollLeft + clientWidth >= scrollWidth - 50) {
            timelineContainer.scrollTo({
              left: 0,
              behavior: "smooth",
            })
          }
        }, 150)
      },
      false
    )
  }
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default VAPTAsAServiceOverview
